var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dms-collapse',{attrs:{"value":[_vm.NAME]}},[_c('dms-collapse-table',_vm._g({attrs:{"table-disabled":_vm.isZpracuj,"name":_vm.NAME,"label-key":"cmdLogUdalosti","table":_vm.dependentTables.ZakazkaControl}},_vm.tableListeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }